import {React} from '@vht/react-components/libs';
import {AppLayout} from '@vht/react-components';
import DefaultView from '@vht/react-components/views/default';
import InvitationLayout from './layouts/invitation-layout';
import config from './config';

const appId = config.platformManagement.appId;

const UserProfileView = React.lazy(() => import('./views/users/profile'));
const UsersView = React.lazy(() => import('./views/users'));
const RolesView = React.lazy(() => import('./views/roles'));
const AcceptInvitationView = React.lazy(() => import('./views/accept-invitation'));
const SecurityGroupsView = React.lazy(() => import('./views/security-groups'));
const SecurityGroupView = React.lazy(() => import('./views/security-group'));

export const navigation = [
  {
    id: appId,
    name: `${appId}:applicationName`,
    icon: '/images/ic-platform-management-outline.svg',
    children: [
      {
        id: 'users',
        name: `${appId}:users.title`,
        url: `/users`,
        matchExact: true,
        permission: [`${appId}.users`, 'read'],
      },
      {
        name: `${appId}:navigation-group.security`,
        children: [
          {
            id: 'roles',
            name: `${appId}:roles.title`,
            url: `/roles`,
            matchExact: true,
            permission: [`${appId}.roles`, 'read'],
          },
          {
            id: 'security-groups',
            name: `${appId}:security-groups.title`,
            url: `/security-groups`,
            matchExact: true,
            permission: [`${appId}.security_groups`, 'read'],
          },
        ],
      },
    ],
  },
];

export const routes = [
  {
    path: `/`,
    exact: true,
    secure: true,
    layout: AppLayout,
    component: DefaultView,
  },
  {
    path: `/profile`,
    exact: true,
    secure: true,
    layout: AppLayout,
    component: UserProfileView,
  },
  {
    path: `/accept-invitation/:token`,
    exact: true,
    secure: false,
    layout: InvitationLayout,
    component: AcceptInvitationView,
  },
  {
    path: `/users`,
    exact: true,
    secure: true,
    layout: AppLayout,
    component: UsersView,
    permission: [`${appId}.users`, 'read'],
  },
  {
    path: `/roles`,
    exact: true,
    secure: true,
    layout: AppLayout,
    component: RolesView,
    permission: [`${appId}.roles`, 'read'],
  },
  {
    path: `/security-groups`,
    exact: true,
    secure: true,
    layout: AppLayout,
    component: SecurityGroupsView,
    permission: [`${appId}.security_groups`, 'read'],
  },
  {
    path: `/security-groups/:id`,
    exact: true,
    secure: true,
    layout: AppLayout,
    component: SecurityGroupView,
    permission: [`${appId}.security_groups`, ['update', 'create']],
  },
];
